// extracted by mini-css-extract-plugin
export default {"container":"vnzgiYf","buttons":"Nt1aypR","stayHereButton":"DanUf7S"};